import MaterialButton from "../../../../../__snowpack__/pkg/@mui/material/Button.js";
import {lighten} from "../../../../../__snowpack__/pkg/@mui/material/styles.js";
import MaterialTableCell from "../../../../../__snowpack__/pkg/@mui/material/TableCell.js";
import styled from "styled-components";
const getBackgroundColor = ($selected, $hover) => {
  if ($selected) {
    return lighten("rgb(30, 119, 208)", 0.85);
  }
  if ($hover) {
    return lighten("#000", 0.98);
  }
  return "#fff";
};
export const ButtonContainer = styled(MaterialButton).withConfig({
  displayName: "table-cellstyles__ButtonContainer",
  componentId: "sc-1i10hgr-0"
})(["&:focus{", "}"], {
  outline: "2px solid transparent",
  outlineOffset: "2px"
});
export const TableCellContainer = styled(MaterialTableCell).withConfig({
  displayName: "table-cellstyles__TableCellContainer",
  componentId: "sc-1i10hgr-1"
})(["&&{box-shadow:", ";box-shadow:", ";", " left:", ";right:", ";", " ", " background-color:", "}"], ({
  $bxShadow,
  $fixLeft
}) => $bxShadow && $fixLeft && "inset -8px 0 8px -6px #c4c4c4", ({
  $fixRight
}) => $fixRight && "inset 8px 0 8px -6px #c4c4c4", ({
  $fixLeft,
  $fixRight
}) => ($fixLeft || $fixRight) && {
  position: "sticky",
  zIndex: "10"
}, ({
  $fixLeft,
  $fixWidth
}) => $fixLeft ? `${$fixWidth}px` : "auto", ({
  $fixRight,
  $fixWidth
}) => $fixRight ? `${$fixWidth}px` : "auto", ({
  $hidden
}) => $hidden && {
  display: "none"
}, ({
  $header,
  $pointer
}) => $header && $pointer && {
  cursor: "pointer"
}, ({
  $selected,
  $hover
}) => getBackgroundColor($selected, $hover));
